import { CategoryID } from '@sbt-web/network/types';
import type { DisplayStrategyCallback } from '.';

export function create(): DisplayStrategyCallback {
  return (search) => {
    return new Promise((resolve) =>
      resolve(
        !(
          search.category.id === CategoryID.Tutte &&
          search.geo.region.id === '0' &&
          (search.query == undefined || !search.query.length)
        )
      )
    );
  };
}
